// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider } from './contexts/ThemeContext';
import { CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useThirdPartyCookies } from './hooks/useThirdPartyCookies';


// Only needed imports
import Login from './pages/Login';
import MicrosoftCallback from './pages/MicrosoftCallback';
import MainLayout from './components/layout/MainLayout';
import routes from './routes';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  return children;
};

const AppRoutes = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <Login />
          )
        } 
      />

      <Route 
        path="/auth/microsoft/callback" 
        element={<MicrosoftCallback />} 
      />

      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        {routes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              route.roles?.includes(user?.role) ? (
                route.element
              ) : (
                <Navigate to="/dashboard" replace />
              )
            }
          />
        ))}
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const App = () => {
  useThirdPartyCookies();
  return (
    <MuiThemeProvider theme={createTheme()}>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || 'unconfigured.apps.googleusercontent.com'}>
        <ThemeProvider>
          <CssBaseline />
          <AuthProvider>
            <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <AppRoutes />
            </BrowserRouter>
          </AuthProvider>
        </ThemeProvider>
      </GoogleOAuthProvider>
    </MuiThemeProvider>
  );
};

export default App;